<template>
	<section class="other_page_banner basset banner_nxt_sec_touch">
		<div class="container">
			<div class="row">
				<div class="col-sm-6 order-2 order-md-1">
					<div class="ban_lt">
						<h2>
							{{
								$t(
									'new_ui.business_asset_management_page.section_banner.title.one',
								)
							}}
						</h2>
						<h6>
							{{
								$t(
									'new_ui.business_asset_management_page.section_banner.main_title.one',
								)
							}}
							<span>{{
								$t(
									'new_ui.business_asset_management_page.section_banner.main_title.two',
								)
							}}</span>
						</h6>
						<p>
							{{
								$t(
									'new_ui.business_asset_management_page.section_banner.paragraph.one',
								)
							}}
						</p>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center p-top"
						></div>
					</div>
				</div>
				<div class="col-sm-6 order-1 order-md-2">
					<div class="ban_rt">
						<img :src="img.image1" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="question_sec method_mid">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 border_dash">
					<div class="row">
						<div class="col-sm-5">
							<div class="question_lt">
								<img :src="img.image2" alt="" />
							</div>
						</div>
						<div class="col-sm-7">
							<div class="question_rt">
								<div class="payment_world_right">
									<span>{{
										$t(
											'new_ui.business_asset_management_page.question_sec.label',
										)
									}}</span>
									<div class="payment_world_txt">
										<h4>
											{{
												$t(
													'new_ui.business_asset_management_page.question_sec.title.one',
												)
											}}
											<br />{{
												$t(
													'new_ui.business_asset_management_page.question_sec.title.two',
												)
											}}
											<span>{{
												$t(
													'new_ui.business_asset_management_page.question_sec.title.three',
												)
											}}</span>
										</h4>
										<p>
											{{
												$t(
													'new_ui.business_asset_management_page.question_sec.paragraph.one',
												)
											}}
										</p>
										<p>
											{{
												$t(
													'new_ui.business_asset_management_page.question_sec.paragraph.two',
												)
											}}
										</p>
										<div class="starting_to_btn pay_world">
											<a href="/auth/register">{{
												$t(
													'new_ui.business_asset_management_page.question_sec.cta_buttons.one',
												)
											}}</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="online_mid business_asset_btm">
		<div class="container">
			<div class="row">
				<div
					class="col-sm-12 col-xxl-6 col-xl-6 col-lg-6 col-md-12 d-block d-md-none"
				>
					<div class="business_anywhere_rt">
						<img :src="img.image4" alt="" />
					</div>
				</div>
				<div class="col-sm-12 col-xxl-6 col-xl-6 col-lg-6 col-md-12">
					<div class="business_anywhere_lt">
						<span>{{
							$t(
								'new_ui.business_asset_management_page.business_asset_btm.label',
							)
						}}</span>
						<div class="business_anywhere_txt">
							<h4>
								{{
									$t(
										'new_ui.business_asset_management_page.business_asset_btm.title.one',
									)
								}}
								<span>{{
									$t(
										'new_ui.business_asset_management_page.business_asset_btm.title.two',
									)
								}}</span
								>,
								{{
									$t(
										'new_ui.business_asset_management_page.business_asset_btm.title.three',
									)
								}}
								<span>{{
									$t(
										'new_ui.business_asset_management_page.business_asset_btm.title.four',
									)
								}}</span>
								{{
									$t(
										'new_ui.business_asset_management_page.business_asset_btm.title.five',
									)
								}}
							</h4>
							<p>
								{{
									$t(
										'new_ui.business_asset_management_page.business_asset_btm.paragraph.one',
									)
								}}
							</p>
							<div class="starting_to_btn">
								<a href="/auth/register">{{
									$t(
										'new_ui.business_asset_management_page.business_asset_btm.cta_buttons.one',
									)
								}}</a>
							</div>
						</div>
					</div>
				</div>
				<div
					class="col-sm-12 col-xxl-6 col-xl-6 col-lg-6 col-md-12 d-none d-md-flex"
				>
					<div class="business_anywhere_rt">
						<img :src="img.image3" alt="" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t(
								'new_ui.business_asset_management_page.section_newsletter.label',
							)
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t(
										'new_ui.business_asset_management_page.section_newsletter.title.one',
									)
								}}</span>
								{{
									$t(
										'new_ui.business_asset_management_page.section_newsletter.title.two',
									)
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.business_asset_management_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.business_asset_management_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.business_asset_management_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.business_asset_management_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
import ba1 from '@/assets/images/sub/ba1.png';
import ba2 from '@/assets/images/sub/ba2.png';
import ba3 from '@/assets/images/sub/ba3.png';
import ba4 from '@/assets/images/sub/ba_mob.png';

export default {
	data: () => {
		return {
			img: {
				image1: ba1,
				image2: ba2,
				image3: ba3,
				image4: ba4,
			},
		};
	},
};
</script>
